import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {NormalsOperatorParameters} from "#template/nodes/geometry-graph/attribute/normals-operator/geometry-normals-operator-node"
import {
    GeometryNormalsOperatorNode,
    normalsOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/normals-operator/geometry-normals-operator-node"

const definition: TemplateNodeDefinition<NormalsOperatorParameters> = {
    nodeClass: "MeshGeometryNormalsOperator",
    validation: {
        parameters: normalsOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryNormalsOperator extends GeometryNormalsOperatorNode implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
